import { useContext } from "react";
import { JointBillContext } from "@features/JointBillList/utils";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const HeaderTotalCellSkeleton: React.FC = () => {
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="flex flex-col items-center gap-3 md:flex-row md:gap-4">
      <Skeleton className="hidden w-28 text-lg md:block" />
      {!isSummaryMode && (
        <>
          <Skeleton className="h-5 w-5" />
          <Skeleton className="h-2.5 w-5 md:hidden" />
        </>
      )}
    </div>
  );
};
